import { defer } from 'react-router-dom'
import useAppStore, { isAppStateReady } from 'src/state/store'
import { CompanyPreferences, logger } from '$utils'
import usePayrollStore from '../../store'
import { PayrollSystem } from '$constants'

export default async function loader({ params }) {
  logger.debug(
    '[loader] About to await AppState being ready in Edit Pay run loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in Edit Pay run loader')

  const { activeCompany } = useAppStore.getState()
  const payrollSystemPreference: string | null = activeCompany?.preference(
    CompanyPreferences.PayrollSystem
  )

  const getPayRun =
    params.payRunId && payrollSystemPreference
      ? usePayrollStore
          .getState()
          .getPayRun(
            params.payRunId,
            payrollSystemPreference as unknown as PayrollSystem
          )
      : null

  return defer({
    data: Promise.all([getPayRun])
      .then(() => true)
      .catch((error) => {
        logger.error('Edit Pay Run Promise.all error', error)
        return false
      }),
  })
}
